export enum ProductId {
  HOHHInsurance = 11,
  HOHHTakaful = 12,
  MyRumahInsurance = 13,
  MyRumahTakaful = 14,
}
